import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store ={
  namespaced: true,
  state:{ 
    // 1层级 默认使用 titile
    // 多层级breadcrumb，menuBreadcrumb归属所处
    // meta {
    //   breadcrumb:['news','vot','detail'],
    //   key: 'detail',
    // }
    // 设置面包屑，beforeRouteEnter对应去自己的{name,path}
    "breadcrumb":{
      linkList:{},// 下拉框选项:误删，删了会导致初次无法监听到变化
    },
  },
  mutations:{
    clearKeyBreadcrumb(state){
      for(let name in state.breadcrumb){
        delete state.key[name];
      }
    },
    setKeyBreadcrumb(state,obj){
      state.breadcrumb[obj.key] = obj;
    },
  },
  getters:{
    getBreadcrumb:(state)=>{
      return state.breadcrumb
    },
    keyGetBreadcrumb:(state)=>{
      return (key)=>state.breadcrumb[key]
    },
  },
  actions:{//异步修改
  }
}

export default store

